import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const TABS = [
  { id: 'about', label: 'About' },
  { id: 'use', label: 'How to use' },
  { id: 'safety', label: 'Good to know' },
];

const USE_TEXT = 'Always read the label and the leaflet inside the pack before use. Follow the directions for the recommended amount and frequency, and do not exceed the stated dose.';
const SAFETY_TEXT = 'Keep out of the sight and reach of children. Store in a cool, dry place. If symptoms persist, worsen, or you are pregnant, breastfeeding or taking other medicines, talk to a pharmacist or doctor first.';

export const InfoTabs = ({ description }) => {
  const [tab, setTab] = useState('about');
  const body = { about: description, use: USE_TEXT, safety: SAFETY_TEXT }[tab];
  return (
    <div className="bg-white rounded-3xl border border-health-line p-2" data-testid="product-info-tabs">
      <div className="flex gap-1 bg-health-mint/60 rounded-2xl p-1">
        {TABS.map((t) => (
          <button key={t.id} onClick={() => setTab(t.id)} className={`relative flex-1 py-2.5 text-sm font-semibold rounded-xl transition-colors ${tab === t.id ? 'text-health-ink' : 'text-slate-500 hover:text-health-emerald'}`} data-testid={`info-tab-${t.id}`}>
            {tab === t.id && <motion.span layoutId="info-tab-bg" className="absolute inset-0 bg-white rounded-xl shadow-sm" transition={{ type: 'spring', stiffness: 400, damping: 32 }} />}
            <span className="relative">{t.label}</span>
          </button>
        ))}
      </div>
      <AnimatePresence mode="wait">
        <motion.p key={tab} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.25 }} className="p-5 text-slate-600 leading-relaxed whitespace-pre-line" data-testid={tab === 'about' ? 'product-description' : `info-tab-content-${tab}`}>
          {body}
        </motion.p>
      </AnimatePresence>
    </div>
  );
};

export default InfoTabs;
